module.exports = __webpack_public_path__ + "img/select-circle.f83d279e.svg";